// useIsFavorited.js
import { useSelector } from 'react-redux';

export const useIsFavorited = (str) => {
  const favoritesArray = useSelector((state) => state.favoritesArray);
  return favoritesArray.includes(str.toUpperCase());
};

// export default useIsStringInFavorites;
